'use client';

import { Section } from 'Njangy/app/[lang]/home/shared/section';
import s from 'Njangy/app/[lang]/security/showcase/styles.module.css';
import {
  landingSecurityCard1Body,
  landingSecurityCard1Title,
  landingSecurityCard2Body,
  landingSecurityCard2Title,
  landingSecurityCard3Body,
  landingSecurityCard3Title,
  landingSecurityCard4Body,
  landingSecurityCard4Title,
  landingSecurityCard5Body,
  landingSecurityCard5Title,
  landingSecurityCard6Body,
  landingSecurityCard6Title,
} from 'Njangy/translations';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

const LockIcon = () => (
  <svg aria-hidden='true' viewBox='0 0 24 24'>
    <rect height={11} rx={2} width={18} x={3} y={11} />
    <path d='M7 11V7a5 5 0 0 1 10 0v4' />
  </svg>
);

const KycIcon = () => (
  <svg aria-hidden='true' viewBox='0 0 24 24'>
    <path d='M20 7 L9 18 L4 13' />
  </svg>
);

const LedgerIcon = () => (
  <svg aria-hidden='true' viewBox='0 0 24 24'>
    <path d='M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z' />
  </svg>
);

const IsolationIcon = () => (
  <svg aria-hidden='true' viewBox='0 0 24 24'>
    <circle cx={12} cy={12} r={10} />
    <path d='M2 12h20' />
    <path d='M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z' />
  </svg>
);

const RailsIcon = () => (
  <svg aria-hidden='true' viewBox='0 0 24 24'>
    <path d='M12 2 2 7l10 5 10-5-10-5z' />
    <path d='M2 17l10 5 10-5' />
    <path d='M2 12l10 5 10-5' />
  </svg>
);

const ShieldIcon = () => (
  <svg aria-hidden='true' viewBox='0 0 24 24'>
    <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
  </svg>
);

export const SecurityShowcase = () => {
  const params = useParams();
  const language = getLanguageFromLocale(params?.lang as string);

  const cards = [
    { body: landingSecurityCard1Body[language], icon: <LockIcon />, title: landingSecurityCard1Title[language] },
    { body: landingSecurityCard2Body[language], icon: <KycIcon />, title: landingSecurityCard2Title[language] },
    { body: landingSecurityCard3Body[language], icon: <LedgerIcon />, title: landingSecurityCard3Title[language] },
    { body: landingSecurityCard4Body[language], icon: <IsolationIcon />, title: landingSecurityCard4Title[language] },
    { body: landingSecurityCard5Body[language], icon: <RailsIcon />, title: landingSecurityCard5Title[language] },
    { body: landingSecurityCard6Body[language], icon: <ShieldIcon />, title: landingSecurityCard6Title[language] },
  ];

  return (
    <Section id='security' testId='security-section'>
      <div className={s.grid}>
        {cards.map((card, i) => (
          <div className={s.card} data-testid={`security-card-${i}`} key={card.title}>
            <div className={s.cardIcon}>{card.icon}</div>
            <h4 className={s.cardTitle}>{card.title}</h4>
            <p className={s.cardBody}>{card.body}</p>
          </div>
        ))}
      </div>
    </Section>
  );
};
